export enum ProfileRole {
  AGENT = 'Consultor',
  ADMIN = 'Admin',
}
